import { DEFAULT_EDITABLE_STATE_INFO } from 'common/constants';
import { SELECTION_TYPES } from 'client/components/common/SelectionHint/utils';
import { SelectionSingleType } from 'client/components/common/SelectionHint/types';

const initialState: {
	state: typeof DEFAULT_EDITABLE_STATE_INFO;
	selection: {
		[SELECTION_TYPES.clicked]: {
			[key: string]: SelectionSingleType;
		};
		[SELECTION_TYPES.hovered]: {
			[key: string]: SelectionSingleType;
		};
	};
} = {
	state: DEFAULT_EDITABLE_STATE_INFO,
	selection: {
		[SELECTION_TYPES.clicked]: {},
		[SELECTION_TYPES.hovered]: {},
		/*
		 [selectionType]: {
		    elementID: {...data},
		    elementID: {...data},
		 },
		*/
	},
};

export default initialState;
